'use client'

import React from 'react'

import { chakra } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import {
  imagePreviewEmptyStyles,
  imagePreviewFrameStyles,
  imagePreviewImageStyles,
} from './ImagePreview.styles'

export type ImagePreviewProps = {
  alt: string
  src?: string | null
  colorScheme?: ColorScheme
  emptyLabel?: string
  height?: string
  objectFit?: 'cover' | 'contain'
  onExpand?: () => void
}

export const ImagePreview = ({
  alt,
  src,
  colorScheme = 'dark',
  emptyLabel,
  height = '280px',
  objectFit = 'cover',
  onExpand,
}: ImagePreviewProps) => {
  const isInteractive = Boolean(src && onExpand)
  const frameStyles = imagePreviewFrameStyles(
    colorScheme,
    isInteractive,
    height
  )

  if (!src) {
    return (
      <chakra.div {...frameStyles}>
        {emptyLabel && (
          <chakra.span {...imagePreviewEmptyStyles(colorScheme)}>
            {emptyLabel}
          </chakra.span>
        )}
      </chakra.div>
    )
  }

  if (!onExpand) {
    return (
      <chakra.div {...frameStyles}>
        <chakra.img
          alt={alt}
          src={src}
          {...imagePreviewImageStyles(objectFit)}
        />
      </chakra.div>
    )
  }

  return (
    <chakra.button
      aria-label={alt}
      onClick={onExpand}
      type='button'
      {...frameStyles}
    >
      <chakra.img alt={alt} src={src} {...imagePreviewImageStyles(objectFit)} />
    </chakra.button>
  )
}
